import { ColumnMetadata } from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { AssetColumns, Token, Network } from "~/modules/assets/types";
import { sortItemsByProperty } from "~/utils/functions/sortItemsByProperty";
import { uniqueValues } from "~/utils/functions/uniqueValues";
import { NetworkBadge } from "../NetworkBadge";
import { Link } from "~/components/Link";
import { getNetworkURL } from "~/routes";
import { AssetUserEvents } from "~/modules/analytics/events/assets";
import { AssetTableRowData } from "../types";
import { CatalogReferenceDataSlugs } from "~/modules/catalog/types";

// // // //

export const NETWORKS_COLUMN: ColumnMetadata<AssetTableRowData, AssetColumns> =
    {
        slug: AssetColumns.networkIDs,
        sortsOn: AssetColumns.networkIDs,
        label: "Networks",
        tooltip: CatalogReferenceDataSlugs.network,
        type: "string",
        width: 140,
        render: (item) => {
            if (item.isAsset) {
                const allNetworks = item.tokens.map((t) => t.network);

                const uniqueNetworksSlugs = uniqueValues(
                    item.tokens.map((t) => t.network.slug),
                );

                const unsortedNetworks = uniqueNetworksSlugs
                    .map((slg) => {
                        return allNetworks.find((each) => each.slug === slg);
                    })
                    .filter((each) => each !== undefined) as Array<Network>;

                const uniqueNetworks = sortItemsByProperty({
                    items: unsortedNetworks,
                    field: "name",
                    direction: "desc",
                });

                if (uniqueNetworks.length === 1) {
                    const token = item.tokens[0] as Token;

                    if (token.network.slug === "book-entry") {
                        return (
                            <div className="py-0.5 px-0.5 flex items-center">
                                <NetworkBadge
                                    network={token.network}
                                    isLink={false}
                                />
                                <p className="ml-2 dg-overflow">
                                    {token.network.name}
                                </p>
                            </div>
                        );
                    }

                    return (
                        <Link
                            variant="default"
                            className="py-0.5 px-0.5 flex items-center"
                            analyticsLabel={AssetUserEvents.ClickNetworkLink}
                            analyticsEventProperties={{
                                network: token.network.slug,
                            }}
                            href={getNetworkURL({
                                networkSlug: token.network.slug,
                            })}
                        >
                            <NetworkBadge
                                network={token.network}
                                enableTooltip={false}
                            />
                            <p className="ml-2 dg-overflow">
                                {token.network.name}
                            </p>
                        </Link>
                    );
                }

                return (
                    <div className="py-0.5 px-0.5 isolate flex -space-x-2 overflow-hidden h-full items-center w-full">
                        {uniqueNetworks.map((n) => {
                            if (n.slug === "book-entry") {
                                return (
                                    <NetworkBadge
                                        key={n.slug}
                                        network={n}
                                        isLink={false}
                                    />
                                );
                            }

                            return (
                                <Link
                                    key={n.slug}
                                    href={getNetworkURL({
                                        networkSlug: n.slug,
                                    })}
                                    analyticsLabel={
                                        AssetUserEvents.ClickNetworkLogoLink
                                    }
                                    analyticsEventProperties={{
                                        network: n.slug,
                                    }}
                                >
                                    <NetworkBadge network={n} />
                                </Link>
                            );
                        })}
                    </div>
                );
            }

            return <Emdash />;
        },
    };
